import React from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';

import I18n from 'utils/I18n';

import { getPackageClassName } from 'apps/summit/shared/utils/package-utils';
import FeatureItem from 'apps/summit/shared/FeatureItem';
import Icon from 'apps/summit/shared/Icon';

import styles from './index.scss';

class PackageItem extends React.Component {
  state = {
    showLearnMoreContent: false
  };

  baseClassName = () => {
    const { packageKey } = this.props;
    const packageClass = styles[getPackageClassName(packageKey)];

    return `${styles.base} ${packageClass}`;
  };

  learnMoreBtnText = () =>
    this.state.showLearnMoreContent
      ? I18n.t('strava.premium.package_select.package_list.cta.close')
      : I18n.t('strava.premium.package_select.package_list.cta.learn_more');

  handleShowLearnMoreContentToggle = () => {
    this.setState((prevState) => ({
      showLearnMoreContent: !prevState.showLearnMoreContent
    }));
  };

  renderActions = () => {
    const { showLearnMoreContent } = this.state;

    return (
      <div className={styles.actions}>
        <button
          data-test="learn-more-toggle-btn"
          className={`btn btn-link btn-icon ${styles.btnLearnMore}`}
          onClick={this.handleShowLearnMoreContentToggle}
        >
          <Icon type={showLearnMoreContent ? 'remove' : 'info'} />
          {this.learnMoreBtnText()}
        </button>
      </div>
    );
  };

  render() {
    const { packageKey, title, description, features } = this.props;
    const { showLearnMoreContent } = this.state;

    return (
      <div id={packageKey} className={this.baseClassName()}>
        <div className={styles.details}>
          <div className={styles.head}>
            <h4 className={styles.title}>{title}</h4>
          </div>

          <p className={styles.description}>{description}</p>

          {this.renderActions()}
        </div>

        <div className={styles.learnMore}>
          <AnimateHeight
            duration={400}
            height={showLearnMoreContent ? 'auto' : 0}
          >
            <div className={styles.divider} />

            <div className={styles.featureList}>
              {features.map((feature) => (
                <div key={feature.name} className={styles.featureItem}>
                  <FeatureItem feature={feature} />
                </div>
              ))}
            </div>

            <div className={styles.divider} />

            {this.renderActions()}
          </AnimateHeight>
        </div>
      </div>
    );
  }
}

PackageItem.defaultProps = {
  trialInfo: null
};

PackageItem.propTypes = {
  packageKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ).isRequired,
  trialInfo: PropTypes.shape({})
};

export default PackageItem;
